import { BlogPost, NavItem } from './types';

export const NAV_ITEMS: NavItem[] = [
  { label: 'Writing', href: '#blog' },
  // { label: 'Work', href: '#projects' },
  { label: 'About', href: '#about' },
];

export const BLOG_POSTS: BlogPost[] = [
  {
    id: '1',
    title: 'What is podman',
    excerpt: 'Podman is a container management tool.',
    date: 'MAY 9, 2025',
    readTime: '5 min',
    tags: ['Podman', 'Container'],
    slug: 'podman',
    featured: true,
  },
  {
    id: '2',
    title: 'Start The Podman',
    excerpt: 'Start the Podman container with the command.',
    date: 'October 30, 2025',
    readTime: '8 min',
    tags: ['Podman', 'Container'],
    slug: 'podman-start',
    featured: true,
  },
  {
    id: '3',
    title: 'Podman Persistence',
    excerpt: 'Service persistence of podman.',
    date: 'November 4, 2025',
    readTime: '15 min',
    tags: ['Podman', 'Container'],
    slug: 'podman-persistence',
  },
  {
    id: '4',
    title: 'Vite Performance Optimization',
    excerpt: 'Optimization analysis of Vite document official website.',
    date: 'November 10, 2025',
    readTime: '20 min',
    tags: ['Design', 'Vite', 'Performance Optimization'],
    slug: 'vite-po',
  },
  {
    id: '5',
    title: 'Use Svelte State In React',
    excerpt: 'The Basic Implementation of $state of svelte in React.',
    date: 'November 14, 2025',
    readTime: '20 min',
    tags: ['Svelte', 'React'],
    slug: 'dollar-state',
  },
  {
    id: '6',
    title: 'Use Svelte effect In React',
    excerpt: 'The Basic Implementation of $effect of svelte in React.',
    date: 'Mar 20',
    readTime: '15 min',
    tags: ['Svelte', 'React'],
    slug: 'dollar-effect',
  },
  {
    id: '7',
    title: 'Use Svelte Derived In React',
    excerpt: 'The Basic Implementation of $Svelte of svelte in React.',
    date: 'November 20, 2025',
    readTime: '17 min',
    tags: ['Svelte', 'React'],
    slug: 'dollar-derived',
  },
  {
    id: '8',
    title: 'Svelte\'s Version Checking',
    excerpt: 'Svelte\'s version checking and updating mechanism.',
    date: 'November 25, 2025',
    readTime: '20 min',
    tags: ['Svelte', 'Version Checking'],
    slug: 'svelte-checkversion',
  },
  {
    id: '9',
    title: 'Svelte Basic Render',
    excerpt: 'Svelte basic rendering process.',
    date: 'November 28, 2025',
    readTime: '22 min',
    tags: ['Svelte', 'Rendering Process'],
    slug: 'svelte-base-render',
  },
  {
    id: '10',
    title: 'Source Code Of Svelte Effect',
    excerpt: 'SVELTE source code analysis: how to create an effect.',
    date: 'December 9, 2025',
    readTime: '22 min',
    tags: ['Svelte', 'Rendering Process'],
    slug: 'svelte-code-effect',
  },
  {
    id: '11',
    title: 'Source Code Of Svelte Array Rendering',
    excerpt: 'SVELTE source code analysis: array rendering and DIFF algorithm.',
    date: 'December 12, 2025',
    readTime: '22 min',
    tags: ['Svelte', 'Array Rendering'],
    slug: 'svelte-code-array',
  },
];